import { type JSX } from "react";
import { cn, formatdDate, parseDateString } from "../../lib/utils";
import { TooltipCell } from "../table/TooltipCell";
import Button from "../shared/ui/Button/baseBtn";
import { IconMaterial } from "../shared/iconMaterial/IconMaterial";
import DropdownMenu from "../dropdown/DropDownMenu";
import { TDevice, useDevices } from "../../context/DeviceProvider";
import Badge from "../shared/ui/Badge";


type BodyTableProps = {
  id?: string | null;
  rows: TDevice[];
  handleRowClick: (device: TDevice) => void
  isPagination?: boolean;
  isLoadingSendInvitation: boolean;
  onRowClick?: (id: string) => void;
  handleClickInviteButton: (id: string) => void;
};

export const BodyTableDevices = ({
  rows,
  isPagination,
  handleRowClick,
}: BodyTableProps): JSX.Element => {
  const baseCellClassName = cn(
    "p-[12px] typo-body-small-deviceium-14 text-black text-sm text-primary-light",
    "align-middle min-w-0",
  );

  const { selectedDevice } = useDevices();

  return (
    <>
      {rows.map((device) => {
        return (
          <tr
            key={device.id}
            className={` ${selectedDevice?.id === device?.id ? 'bg-background-light-gray' : ''}`}>
            <td
              onClick={() => handleRowClick(device)}
              className={cn(
                baseCellClassName,
                "relative overflow-hidden cursor-pointer group",
                selectedDevice?.id === device?.id ? "border-l-[2px] border-primeblue" : ""
              )}
            >
              <div className="rounded-l-lg flex items-center">
                <span className="truncate group-hover:text-primeblue">
                  {device.name}
                </span>
                <IconMaterial
                  filled
                  icon="chevron_right"
                  className="cursor-pointer hidden group-hover:block group-hover:text-primeblue"
                  size={16}
                />
              </div>
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={device.manufacturer} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={device.model} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={device.department} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={formatdDate(device.created_stamp)} />
            </td>

            <td className={cn(baseCellClassName)}>
              <Badge
                status={device.status}
              />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={formatdDate(device.last_health_check)} />
            </td>
          </tr>
        );
      })}
    </>
  );
};
